export class ClientWindow {};
